export const VCARD_EXTRA_POSITIONS = [
    'Business Development',
    'Solution Specialist',
]

export const VCARD_SOCIAL_PLATFORMS = [
    { label: 'Facebook', value: 'facebook' },
    { label: 'Twitter', value: 'twitter' },
    { label: 'Instagram', value: 'instagram' },
    { label: 'LinkedIn', value: 'linkedin' },
    { label: 'TikTok', value: 'tiktok' },
    { label: 'YouTube', value: 'youtube' },
    { label: 'Pinterest', value: 'pinterest' },
    { label: 'Reddit', value: 'reddit' },
    { label: 'Discord', value: 'discord' },
    { label: 'Telegram', value: 'telegram' },
    { label: 'WhatsApp', value: 'whatsapp' },
]
